import React from 'react'

import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  startLocation?: string | null
  endLocation?: string | null
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationWithStartAndEnd({
  startLocation,
  endLocation,
  size = 'large',
}: Props) {
  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      Starts in{' '}
      <Caption as="span" weight="bold" variant={size}>
        {startLocation}
      </Caption>
      , Ends in{' '}
      <Caption as="span" weight="bold" variant={size}>
        {endLocation}
      </Caption>
    </CaptionTextBlock>
  )
}

export default BookmarkLocationWithStartAndEnd
